"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _base = _interopRequireDefault(require("../../atomic/texts/base"));
var _util = require("../../../util");
var BLOCK_CLASS = 'pf-offer-title';
var bem = (0, _util.klass)(BLOCK_CLASS);
var PlanLine = function PlanLine(_ref) {
  var firstLineText = _ref.firstLineText,
    secondLineText = _ref.secondLineText,
    superScript = _ref.superScript;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: bem('plan-line')
  }, /*#__PURE__*/_react.default.createElement(_base.default, null, firstLineText, /*#__PURE__*/_react.default.createElement(_base.default, {
    as: "sup"
  }, superScript)), /*#__PURE__*/_react.default.createElement(_base.default, null, secondLineText));
};
PlanLine.propTypes = {
  firstLineText: _propTypes.default.string.isRequired,
  secondLineText: _propTypes.default.string.isRequired,
  superScript: _propTypes.default.string.isRequired
};
var _default = PlanLine;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');